import {Component, OnInit, ElementRef, Inject , OnDestroy} from '@angular/core';
import {Location , DOCUMENT} from '@angular/common';
import {Router , NavigationEnd } from '@angular/router'
import {PageScrollInstance, PageScrollService, PageScrollConfig} from 'ngx-page-scroll';
import {TrackingServiceService} from '../service/tracking-service.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit , OnDestroy {
    private toggleButton: any;
    private sidebarVisible: boolean;
    currentUrl;

    constructor(public router: Router, private element: ElementRef,
                private pageScrollService: PageScrollService, @Inject(DOCUMENT) private document: any,
                private track: TrackingServiceService) {
        this.sidebarVisible = false;
    }

    ngOnInit() {
        const navbar: HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
        PageScrollConfig.defaultScrollOffset = 70;
        PageScrollConfig.defaultDuration = 800;

        this.router.events.filter((event: any) => event instanceof NavigationEnd)
            .subscribe(event => {
                this.currentUrl = event.url;
            });
    }

    ngOnDestroy() {
        if (this.currentUrl) {
            this.currentUrl.unsubscribe();
        }
    }

    sidebarOpen() {
        const toggleButton = this.toggleButton;
        const html = document.getElementsByTagName('html')[0];
        setTimeout(function () {
            toggleButton.classList.add('toggled');
        }, 500);
        html.classList.add('nav-open');

        this.sidebarVisible = true;
    };

    sidebarClose() {
        const html = document.getElementsByTagName('html')[0];
        this.toggleButton.classList.remove('toggled');
        this.sidebarVisible = false;
        html.classList.remove('nav-open');
    };

    sidebarToggle() {
        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    };

    menu(menuIdName) {
        this.track.eventTracking('click menu', 'menu', menuIdName);
        const pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, '#' + menuIdName);
        this.pageScrollService.start(pageScrollInstance);
        this.sidebarClose();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/navbar/navbar.component.ts